@if (form?.get('investmentGoals')?.value?.length == 0 && derrors) {
  <info [option]="optionInfo1"> vous devez choisir au moins une option </info>
}

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-template #optionTemplate let-option let-id="index">
      @if (check(option.value)) {
        <div class="row">
          <div class="col-md-6">
            <pr-input-column
              label="Nom du prêteur"
              [derrors]="derrors"
              [isDefault]="false"
            >
              <input
                formControlName="investmentGoalGarantyLender"
                type="text"
              />
            </pr-input-column>
          </div>
          <div class="col-md-6">
            <pr-input-column
              label="Instrument de garantie"
              [derrors]="derrors"
              [isDefault]="false"
            >
              <input
                formControlName="investmentGoalGarantyObject"
                type="text"
              />
            </pr-input-column>
          </div>
        </div>
      }
      @if (check2(option.value)) {
        <pr-input-column
          label="Précisez votre objectif"
          [derrors]="derrors"
          [isDefault]="false"
        >
          <input formControlName="investmentGoalDetail" type="text" />
        </pr-input-column>
      }
    </ng-template>
    <ng-template #default></ng-template>

    <div class="checkbox">
      <pr-checkbox-group
        formControlName="investmentGoals"
        [template]="optionTemplate"
        [options]="options"
      >
      </pr-checkbox-group>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
